import { render } from "./TheScreen.vue?vue&type=template&id=5c135402&scoped=true"
import script from "./TheScreen.vue?vue&type=script&lang=js"
export * from "./TheScreen.vue?vue&type=script&lang=js"

import "./TheScreen.vue?vue&type=style&index=0&id=5c135402&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c135402"]])

export default __exports__